import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {RefreshTokenService} from './refresh-token.service';
import {AuthenticationService} from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(
    private http: HttpClient,
    private refreshTokenService: RefreshTokenService,
  ) {
  }

  private loginurl = '';

  initRefreshJwtToken() {
    this.refreshTokenService.refreshJwtToken();
    setInterval(() => {
      this.refreshTokenService.refreshJwtToken();
    }, 14 * 60 * 1000);
  }
}
